import * as React from "react";
import { Diamond, Check, Minus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const features = [{
  title: "Structured Planning",
  description: "Organize your systematic approach with dedicated slots for every trade type, simplifying complex strategies."
}, {
  title: "Pattern Library",
  description: "Access a comprehensive library featuring 16 distinct slot types designed for varied market conditions."
}, {
  title: "AI-Powered Caddie",
  description: "Receive real-time decision structuring and discipline reinforcement from our proprietary AI assistant."
}, {
  title: "Market Analysis",
  description: "Integrate essential market data directly into your planning workflow for informed decision-making."
}, {
  title: "Educational Series",
  description: "Learn from real chart examples and systematic breakdowns through our exclusive video content."
}, {
  title: "Discipline Tracking",
  description: "Monitor your adherence to your trading plan and build consistency without the emotional noise of P&L."
}];
const comparisonData = [{
  feature: "Weekly Planning Slots",
  free: true,
  caddie: true
}, {
  feature: "Basic Pattern Library",
  free: true,
  caddie: true
}, {
  feature: "Educational Content Access",
  free: true,
  caddie: true
}, {
  feature: "AI Decision Structuring",
  free: false,
  caddie: true
}, {
  feature: "Advanced 16-Slot Library",
  free: false,
  caddie: true
}, {
  feature: "Real-time Discipline Alerts",
  free: false,
  caddie: true
}];
export default function ToolCapabilities() {
  return <section id="tool-capabilities" className="dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 font-serif">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="text-center mb-16">
          <h2 className="font-sans text-3xl md:text-4xl font-semibold text-foreground mb-4 tracking-wide">
            Platform Capabilities
          </h2>
          <div className="w-16 h-0.5 bg-primary mx-auto mb-6"></div>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Discover the tools designed to simplify your systematic trading process and enforce discipline.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-24">
          {features.map((feature, i) => <Card key={i} data-index={i} className="bg-card border-none rounded-none shadow-none hover:bg-card/80 transition-colors duration-300">
              <CardHeader className="pb-4">
                <Diamond className="text-primary size-6 mb-4" strokeWidth={1.5} />
                <CardTitle className="font-sans text-xl text-foreground tracking-wide">
                  {feature.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-base text-muted-foreground font-serif leading-relaxed">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>

        {}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="text-center mb-10">
            <h3 className="font-sans text-2xl font-semibold text-foreground tracking-wide">
              Tier Comparison
            </h3>
          </div>
          <div className="border border-border/50 bg-card/50 p-1">
            <Table>
              <TableHeader>
                <TableRow className="border-b border-border/50 hover:bg-transparent">
                  <TableHead className="w-[50%] font-sans text-foreground text-base py-6 pl-6">
                    Features
                  </TableHead>
                  <TableHead className="text-center font-sans text-foreground/50 text-base py-6">
                    Free Tier
                  </TableHead>
                  <TableHead className="text-center font-sans text-primary text-base py-6 pr-6">
                    Caddie Tier
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {comparisonData.map((row, i) => <TableRow key={i} data-index={i} className="border-b border-border/20 even:bg-muted/5 hover:bg-muted/10 transition-colors">
                    <TableCell className="font-serif text-foreground text-lg py-4 pl-6">
                      {row.feature}
                    </TableCell>
                    <TableCell className="text-center py-4">
                      {row.free ? <Check className="text-primary size-5 mx-auto" strokeWidth={2} /> : <Minus className="text-foreground/30 size-5 mx-auto" strokeWidth={2} />}
                    </TableCell>
                    <TableCell className="text-center py-4 pr-6">
                      {row.caddie ? <Check className="text-primary size-5 mx-auto" strokeWidth={2} /> : <Minus className="text-foreground/30 size-5 mx-auto" strokeWidth={2} />}
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </div>
        </div>

        {}
        <div className="flex justify-center mt-12">
          <Link to="/ConnectPage">
            <Button size="lg" className="font-sans rounded-none bg-primary text-primary-foreground hover:bg-primary/90 px-10 py-6 text-lg tracking-wider uppercase">
              Join Waitlist
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}